// Producer link click measurement: the producer name under the product title and the button
// of the producer section. Each link carries data-producer-click (placement),
// data-producer-target (page = producer collection, filter = filtered URL), data-producer-id
// and data-source-product-id. Publishes dyncel_producer_click on the Shopify analytics bus; a
// custom pixel relays it. No network request here, no dependency.

const LINK = 'a[data-producer-click]';

export function publish(name, payload) {
  const bus = globalThis.Shopify && globalThis.Shopify.analytics;
  if (!bus || typeof bus.publish !== 'function') return false;
  bus.publish(name, payload);
  return true;
}

export function clickPayload(link) {
  return {
    placement: link.getAttribute('data-producer-click'),
    target: link.getAttribute('data-producer-target'),
    producer_id: link.getAttribute('data-producer-id'),
    source_product_id: link.getAttribute('data-source-product-id'),
    href: link.getAttribute('href'),
  };
}

export function findLink(target) {
  let node = target;
  while (node) {
    if (typeof node.matches === 'function' && node.matches(LINK)) return node;
    node = node.parentElement;
  }
  return null;
}

export function initProducerTracking(root = document) {
  root.addEventListener('click', (event) => {
    const link = findLink(event.target);
    if (!link) return;
    publish('dyncel_producer_click', clickPayload(link));
  }, { capture: true, passive: true });
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProducerTracking());
  } else {
    initProducerTracking();
  }
}
